<template>
  <div>
    <PageHeader
      :title="`مدیریت ${mode === 'firstBanner' ? ' بنر صفحه اصلی' : mode === 'statisticsBanner' ? ' بنر صفحه آماری' : 'اسلایدر صفحه اصلی'}`"
      :items="mode === 'firstBanner' ? pageHeaderItems[0] : mode === 'statisticsBanner' ? pageHeaderItems[1] : pageHeaderItems[2]"
    />

    <Loader v-if="loading" />
    <form @submit.prevent="onSubmit" class="inner__style" v-else>
      <div class="d-flex flex-column flex-col gap-3">
        <b-row v-if="mode === 'firstBanner'">
          <b-col cols="12" md="6">
            <ImageUploader
              :img="selectedItem.largeImage"
              :uploadLoading="uploadLargeImageLoading"
              :secondTitle="`سایز 1920 * 625`"
              title="عکس بنر را انتخاب کنید"
              @uploadImage="uploadLargeImage"
              @deleteImage="selectedItem.largeImage = ''"
            />
          </b-col>

          <b-col cols="12" md="6">
            <ImageUploader
              :img="selectedItem.smallImage"
              :uploadLoading="uploadSmallImageLoading"
              title="عکس بنر را انتخاب کنید"
              @uploadImage="uploadSmallImage"
              :secondTitle="`سایز 833 * 833`"
              @deleteImage="selectedItem.smallImage = ''"
            />
          </b-col>
        </b-row>

        <b-row v-if="['statisticsBanner', 'sliderBanner'].includes(mode)">
          <b-col>
            <ImageUploader
              :img="selectedItem.largeImage"
              :uploadLoading="uploadLargeImageLoading"
              title="عکس بنر را انتخاب کنید"
              :secondTitle="`سایز ${mode === 'statisticsBanner' ? '390' : '620'} * 1920`"
              @uploadImage="uploadLargeImage"
              @deleteImage="selectedItem.largeImage = ''"
            />
          </b-col>
        </b-row>

        <BaseText v-model="selectedItem.largeImageText" title="متن جایگزین بنر" placeholder="متن جایگزین بنر" labelClass="labelClass" />

        <BaseText v-if="mode === 'firstBanner'" v-model="selectedItem.smallImageText" title="متن جایگزین روی بنر" placeholder="متن جایگزین روی بنر" labelClass="labelClass" />

        <BaseText v-if="['firstBanner', 'sliderBanner'].includes(mode)" v-model="selectedItem.title" title="عنوان" placeholder="عنوان" labelClass="labelClass" />

        <BaseText v-if="['sliderBanner'].includes(mode)" v-model="selectedItem.link" title="لینک روی بنر" placeholder="لینک روی بنر" labelClass="labelClass" :maxlength="10000" />

        <BaseText v-if="mode === 'firstBanner'" v-model="selectedItem.description" title="توضیح کوتاه" placeholder="توضیح کوتاه" labelClass="labelClass" />

        <BaseText v-if="mode === 'sliderBanner'" v-model="selectedItem.order" title="ترتیب بنر" placeholder="ترتیب بنر" labelClass="labelClass" />

        <TextAreaInput v-if="mode === 'sliderBanner'" v-model="selectedItem.description" rows="8" class="__text_area" inputType="text" title="توضیحات" placeholder="توضیحات" />

        <div class="d-flex align-items-center">
          <label style="min-width: 110px; margin-bottom: unset">انتخاب کد رنگ</label>

          <vue-gpickr v-model="gradient" dir="ltr" />

          <b-button variant="primary" style="align-self: flex-end; margin-right: 10px" @click="resetColor">بازنشانی رنگ</b-button>
        </div>

        <div class="d-flex justify-content-end gap-2 mt-3">
          <b-button v-if="mode === 'sliderBanner'" :disabled="mode === 'sliderBanner' && !selectedItem.id" variant="secondary" @click="$bvModal.show('cancelModal')"
            >انصراف</b-button
          >

          <Button text="ثبت" btnClass="upload-btn btn-border" type="submit" :loading="loading" />
        </div>
      </div>
    </form>

    <Toast title="با موفقیت ذخیره شد" submit :showToast="showToast" />

    <b-modal id="cancelModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4">
          <img src="@/assets/images/checked1.svg" />
        </div>

        <div class="error-title">آیا از انصراف خود مطمئن هستید؟</div>

        <div class="buttons">
          <div @click="$bvModal.hide('cancelModal')">
            <button class="cancelButton">خیر</button>
          </div>

          <div @click="redirectToSlider">
            <button class="approveButton">بلی</button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Button from '../../common/Button.vue'
import Loader from '../../widgets/loader.vue'
import fileMannager from '../../../services/file'
import { VueGpickr, LinearGradient } from 'vue-gpickr'
import Toast from '../../../components/common/Toast.vue'
import ImageUploader from '../../user/ImageUploader.vue'
import PageHeader from '../../layoutComponents/page-header.vue'
import BaseText from '../../common/form/formModules/BaseText.vue'
import dadbananSettingProvider from '../../../services/dadban/banners'
import TextAreaInput from '@/components/common/form/formModules/TextAreaInput.vue'

const gradient = new LinearGradient({
  angle: 0,
  stops: [
    ['#0359b534', 0],
    ['#f6ce0143', 1],
  ],
})
export default {
  name: 'AddMentor',
  components: { PageHeader, Loader, BaseText, Button, ImageUploader, Toast, TextAreaInput, VueGpickr },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      gradient,
      loading: false,
      showToast: false,
      uploadLargeImageLoading: false,
      uploadSmallImageLoading: false,
      pageHeaderItems: [
        [
          { text: 'داشبورد', href: '/' },
          { text: 'بنر اول', active: true },
        ],
        [
          { text: 'داشبورد', href: '/' },
          { text: 'بنر آماری', active: true },
        ],
        [
          { text: 'داشبورد', href: '/' },
          { text: 'اسلایدر', active: true },
        ],
      ],
      selectedItem: {
        id: undefined,
        link: undefined,
        style: undefined,
        order: undefined,
        title: undefined,
        largeImage: undefined,
        smallImage: undefined,
        firstColor: undefined,
        thirdColor: undefined,
        description: undefined,
        secondColor: undefined,
        largeImageText: undefined,
        smallImageText: undefined,
      },
    }
  },
  async mounted() {
    if (this.$route.params.id) await this.getBanner()
    if (this.mode === 'firstBanner') await this.getBannerType(1)
    if (this.mode === 'statisticsBanner') await this.getBannerType(3)
    this.setColorGradient()
  },
  methods: {
    resetColor() {
      this.onSubmit()
      this.gradient = new LinearGradient({
        angle: 0,
        stops: [
          ['#0359b534', 0],
          ['#f6ce0143', 1],
        ],
      })
    },
    setColorGradient() {
      if (!this.selectedItem.firstColor) return

      const splitColor = this.selectedItem.firstColor.match(/rgba\([^)]+\)\s*\d*%?/g)
      const uniqueColors = []

      splitColor.forEach((stop) => {
        const rgbaCode = stop.match(/rgba\([^)]+\)/)[0]
        const position = parseFloat(stop.match(/\d+(\.\d+)?%/)[0]) / 100
        let a
        const rgb = rgbaCode.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i)
        const alpha = ((rgb && rgb[4]) || '').trim()
        let hex = rgb ? (rgb[1] | (1 << 8)).toString(16).slice(1) + (rgb[2] | (1 << 8)).toString(16).slice(1) + (rgb[3] | (1 << 8)).toString(16).slice(1) : rgbaCode
        if (alpha !== '') {
          a = alpha
        } else {
          a = 1
        }

        a = ((a * 255) | (1 << 8)).toString(16).slice(1)
        hex = hex + a

        uniqueColors.push([`#${hex}`, position])
      })

      this.gradient = new LinearGradient({
        angle: this.selectedItem.firstColor.match(/(-?\d+)/)[0],
        stops: uniqueColors,
      })
    },
    async uploadLargeImage(e) {
      this.uploadLargeImageLoading = true
      const req = await fileMannager.addImage({
        base64image: e.dataUrl,
      })
      this.uploadLargeImageLoading = false
      this.selectedItem.largeImage = req.data.data.downloadUrl
    },
    async uploadSmallImage(e) {
      this.uploadSmallImageLoading = true
      const req = await fileMannager.addImage({
        base64image: e.dataUrl,
      })
      this.uploadSmallImageLoading = false
      this.selectedItem.smallImage = req.data.data.downloadUrl
    },
    async getBanner() {
      try {
        const result = await dadbananSettingProvider.getBanner({ id: Number(this.$route.params.id) })
        if (result.status === 200) this.selectedItem = result.data.data.output
      } catch (error) {
        return false
      }
    },
    async getBannerType(type) {
      try {
        const result = await dadbananSettingProvider.getBannerType({ type })
        if (result.status === 200) this.selectedItem = result.data.data.output
      } catch (error) {
        return false
      }
    },

    onPickColor() {
      this.gradient.stops.sort((a, b) => a[1] - b[1])

      const colors = []
      let gradientColor
      for (let i = 0; i < this.gradient.stops.length; i++) {
        const clr = this.gradient.stops[i][0]
        const r = parseInt(clr.substring(1, 3), 16)
        const g = parseInt(clr.substring(3, 5), 16)
        const b = parseInt(clr.substring(5, 7), 16)
        const a = parseInt(clr.substring(7, 9), 16) / 255

        const rgbaColor = `rgba(${r}, ${g}, ${b}, ${a})`
        colors.push([rgbaColor, this.gradient.stops[i][1]])
        gradientColor = colors.map(([color, position]) => `${color} ${position * 100}%`).join(', ')
      }

      this.selectedItem.firstColor = `${this.gradient.type}-gradient(${this.gradient.angle}deg,${gradientColor})`
    },
    async storeFirstBanner() {
      this.onPickColor()
      try {
        let req
        if (this.selectedItem.id) req = await dadbananSettingProvider.updateBanner({ ...this.selectedItem, secondColor: undefined, thirdColor: undefined })
        else req = await dadbananSettingProvider.insertFirstBanner({ ...this.selectedItem, secondColor: undefined, thirdColor: undefined })
      } catch (error) {
        return false
      }
    },
    async storeSecondBanner() {
      this.onPickColor()
      try {
        let req
        if (this.selectedItem.id) req = await dadbananSettingProvider.updateBanner({ ...this.selectedItem, secondColor: undefined, thirdColor: undefined })
        else
          req = await dadbananSettingProvider.insertSecondBanner({
            ...this.selectedItem,

            secondColor: undefined,
            thirdColor: undefined,
            order: Number(this.selectedItem.order),
          })

        if (!this.selectedItem.id && req.status === 200) this.redirectToSlider()
      } catch (error) {
        return false
      }
    },
    async storeThirdBanner() {
      this.onPickColor()
      try {
        let req
        if (this.selectedItem.id) req = await dadbananSettingProvider.updateBanner({ ...this.selectedItem, secondColor: undefined, thirdColor: undefined })
        else req = await dadbananSettingProvider.insertThirdBanner({ ...this.selectedItem, secondColor: undefined, thirdColor: undefined })
      } catch (error) {
        return false
      }
    },
    async onSubmit() {
      this.showToast = false
      this.loading = true
      try {
        if (this.mode === 'firstBanner') await this.storeFirstBanner()
        else if (this.mode === 'statisticsBanner') await this.storeThirdBanner()
        else if (this.mode === 'sliderBanner') await this.storeSecondBanner()
        this.showToast = true
        this.loading = false
      } catch (error) {
        this.showToast = false
        this.loading = false
      }
    },
    redirectToSlider() {
      this.$router.push('/list/slider')
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .labelClass {
  min-width: 100px !important;
}

.inner__style {
  background-color: white;
  padding: 23px;
}

.__color {
  width: 100%;
  border: 1px solid rgb(219, 214, 207);
  border-radius: 4px;
  height: 2.06875rem;
  display: flex;
  align-items: center;
  gap: 2;
}

.__input_color {
  width: inherit;
  background-color: unset;
  height: 2.06875rem;
  border: none;
  outline: none;
}

.upload-btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
  width: 119.1px;
}

.__text_area {
  width: 100%;
  border-color: #ced4da;
  border-radius: 4px;
  padding: 6px 10px;
}

.__text_area:focus-visible {
  outline: none;
}

.error-wrapper {
  text-align: center;
  * {
    color: #4a4a4a;
    font-style: normal;
    font-weight: normal;
  }

  .error-title {
    font-size: 16px;
    margin-bottom: 40px;
    line-height: 23px;
  }

  .error-text {
    font-size: 14px;
    line-height: 20px;
    margin: 25px 0;
  }
  button {
    font-size: 16px;
    line-height: 23px;
    background-color: transparent;
    outline: none;
    border: none;
  }
  .buttons {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .approveButton {
    padding: 6px 90px;
    color: white;
    background: #556ee6;
    border-radius: 4px;
  }
  .cancelButton {
    padding: 6px 90px;
    margin-left: 12px;
    color: white;
    background: #74788d;
    border-radius: 4px;
  }
}
</style>
